import React from "react";
import { Table } from "antd";
import { Flex, Label, Text } from "@fluentui/react-northstar";
import { useTranslation } from "react-i18next";

const RubricsView = ({ rubrics }) => {
  const { t } = useTranslation();

  const translation = t("assignment").summary.rubrics;

  const columns = [
    {
      title: translation.criteria,
      dataIndex: "criteriaTitle",
      key: "criteriaTitle",
      fixed: "left",
      width: 200,
      render: (text, record) => (
        <Text weight="bold" color={record.isParent ? "brand" : "default"}>
          {record.isParent ? text : `└ ${text}`}
        </Text>
      ),
    },
    {
      title: translation.points,
      dataIndex: "points",
      key: "points",
      width: 100,
      render: (text) => text || "-",
    },
    {
      title: translation.description,
      dataIndex: "description",
      key: "description",
      width: 400,
      ellipsis: true,
    },
  ];

  const formatRubricData = (rubricItems) => {
    let formattedData = [];
    let totalPoints = 0;

    if (!rubricItems?.length) return { formattedData, totalPoints };

    rubricItems.forEach((item) => {
      // Add parent row
      formattedData.push({
        key: `${item.rubricItemId}-parent`,
        criteriaTitle: item.rubricItemTitle,
        isParent: true,
        points: (
          <Label
            circular
            styles={{ backgroundColor: "#eae6ff", color: "#6264a7" }}
            content={translation.maxPoints.replace(
              "{points}",
              Math.max(...item.levels.map((level) => level.points))
            )}
          />
        ),
        description: item.description || "",
      });

      // Add child rows for each level
      item.levels.forEach((level) => {
        formattedData.push({
          key: `${item.rubricItemId}-${level.criteriaId}`,
          criteriaTitle: level.levelTitle,
          points: level.points,
          description: level.description,
        });
      });

      // Add maximum points from each rubric item to total
      totalPoints += Math.max(...item.levels.map((level) => level.points));
    });

    return { formattedData, totalPoints };
  };

  const { formattedData, totalPoints } = formatRubricData(rubrics?.rubricItems);
  const rubricsDataToShow = formattedData?.length ? formattedData : [];

  return (
    <Flex column gap="gap.small">
      <Flex gap="gap.small" space="between">
        <Text size="large" weight="bold">
          {rubrics?.rubricTitle}
        </Text>
        <Label
          circular
          styles={{ backgroundColor: "#eae6ff", color: "#6264a7" }}
          content={translation.totalPoints.replace("{points}", totalPoints)}
        />
      </Flex>
      <div style={{ flex: 1, overflow: "auto" }}>
        <Table
          columns={columns}
          dataSource={rubricsDataToShow}
          pagination={false}
          scroll={{
            x: "max-content",
            y: "calc(100vh - 400px)",
          }}
          style={{
            height: "100%",
          }}
        />
      </div>
    </Flex>
  );
};

export default RubricsView;
